export const sortSchemesAlphabetically = <T extends { name: string; isDefault: boolean }>(
  schemes: T[],
): T[] => {
  return [...schemes].sort((a, b) => {
    if (a.isDefault && !b.isDefault) return -1;
    if (!a.isDefault && b.isDefault) return 1;
    return a.name.trim().localeCompare(b.name.trim());
  });
};

export const sortNamesAlphabetically = <T extends { name: string }>(items: T[]): T[] => {
  return [...items].sort((a, b) => a.name.trim().localeCompare(b.name.trim()));
};

export const sortRangesByStartDateAsc = <T extends { startDate?: string }>(ranges: T[]): T[] => {
  return [...ranges].sort((a, b) => {
    if (!a.startDate && !b.startDate) return 0;
    if (!a.startDate) return -1;
    if (!b.startDate) return 1;
    return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
  });
};
